import pastJob from '../../../dto/pastJobs'
import moment from 'moment'
import {cloneDeep} from 'lodash'
import getApiClient from '@/plugins/api-client'
import media from '../../../dto/media'
import Vue from 'vue'

export default {
    saveWorkProfile: function (profile, errors = {}) {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormMessages(errors)

        let data = self.prepareFields(profile)

        if (!profile.id) {
            return api.post(`work_profiles/${data.category}`, data)
                .then(result => {
                    Object.assign(profile, result.data)
                    profile.pastJobs = result.data.pastJobs
                    profile.types = result.data.types
                    self.fillMediaSlots(profile)
                    if (!profile.pastJobs.length) {
                        self.appendPastJob(profile.pastJobs)
                    }

                    self.$store.commit('addWorkProfile', profile)

                    self.updateSymplaParticipations()
                    self.$parent.showSuccessMessage('Dados salvos!')
                })
                .catch(error => {
                    if ([400, 422].includes(error.response.status)) {
                        self.processErrorMessages(error.response.data, errors)
                    }
                    self.$parent.showErrorMessage('Falha ao salvar dados. Tente novamente.')
                })
        }

        return api.patch(`work_profiles/${data.category}/${profile.id}`, data, {
            'headers': {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.$store.dispatch('storeUserInfo')
                Object.assign(profile, result.data)
                profile.pastJobs = result.data.pastJobs
                profile.types = result.data.types
                self.fillMediaSlots(profile)
                if (!Object.keys(profile.pastJobs).length) {
                    self.appendPastJob(profile.pastJobs)
                }

                self.updateSymplaParticipations()
                self.$parent.showSuccessMessage('Dados salvos!')
            })
            .catch(error => {
                if ([400, 422].includes(error.response.status)) {
                    self.processErrorMessages(error.response.data, errors)
                }
                self.$parent.showErrorMessage('Falha ao salvar dados. Tente novamente.')
            })

    },

    fillMediaSlots: function (profile) {
        let totalMediaSlots = profile.media.length

        if (totalMediaSlots < 5) {
            const difference = 5 - totalMediaSlots

            let hasVideoSlot = profile.media.filter((media) => {
                return media.type === 'video'
            }).length

            for (let index = 0; index < difference; index++) {
                let mediaObj = Object.assign({}, media)
                mediaObj.type = 'photo'

                if (!hasVideoSlot && index === difference - 1) {
                    mediaObj.type = 'video'
                }

                profile.media.push(mediaObj)
            }
        }

        profile.media = profile.media.sort(function (a, b) {
            return a.type > b.type
        });
    },

    appendPastJob: function (pastJobs) {
        let newPastJob = Object.assign({}, pastJob)

        if (Array.isArray(pastJobs)) {
            pastJobs.push(newPastJob)
        }
    },

    removePastJob: function (pastJobs, index) {
        this.$delete(pastJobs, index)
    },

    removeMedia: function (media, index) {
        this.$delete(media, index)
    },

    setJobDate: function (pastJob) {
        if (!pastJob.formattedDate) {
            return
        }

        let date = pastJob.formattedDate.split('/'),
            year = date[2],
            month = date[1],
            day = date[0]

        let rawDate = `${year}-${month}-${day}`
        if (moment(rawDate).isValid()) {
            pastJob.date = rawDate
        } else {
            pastJob.date = ''
            pastJob.formattedDate = ''
        }
    },

    setJobEndDate: function (pastJob) {
        if (!pastJob.formattedEndDate) {
            return
        }

        let date = pastJob.formattedEndDate.split('/'),
            year = date[2],
            month = date[1],
            day = date[0]

        let rawDate = `${year}-${month}-${day}`
        if (moment(rawDate).isValid()) {
            pastJob.endDate = rawDate
        } else {
            pastJob.endDate = ''
            pastJob.formattedEndDate = ''
        }
    },

    setJobFormattedDates: function (pastJob) {
        if (pastJob.date) {
            let date = moment(pastJob.date)

            if (date.isValid()) {
                pastJob.formattedDate = moment(pastJob.date).format('DD/MM/YYYY')
            } else {
                pastJob.formattedDate = ''
            }
        }

        if (pastJob.endDate) {
            let date = moment(pastJob.endDate)

            if (date.isValid()) {
                pastJob.formattedEndDate = moment(pastJob.endDate).format('DD/MM/YYYY')
            } else {
                pastJob.formattedEndDate = ''
            }
        }
    },

    prepareFields: function (profile) {
        const self = this,
            data = cloneDeep(profile)

        for (let field in data) {
            let value = data[field]
            switch (field) {
                case 'pastJobs':
                    value.forEach((pastJob, index) => {
                        if (!pastJob.name && !pastJob.date && !pastJob.type) {
                            self.removePastJob(value, index)
                        }
                        if (!pastJob.date) {
                            pastJob.date = new Date()
                        }
                    })
                    break;
            }
            if (!value) {
                data[field] = null
            }
        }

        if (profile.category === 'event_support') {
            const totalMediaLength = data.media.length - 1;
            for (let index = totalMediaLength; index >= 0; index--) {
                let media = data.media[index]
                if (!media.path) {
                    self.removeMedia(data.media, index)
                }
            }
        } else {
            const totalMediaLength = data.media.length - 1;
            for (let index = totalMediaLength; index > 0; index--) {
                let media = data.media[index]
                if (!media.path) {
                    self.removeMedia(data.media, index)
                }
            }
        }

        if (data.id) {
            self.prepareForUpdate(data)
        }

        if (Array.isArray(profile.types)) {
            profile.types = profile.types.filter(item => {
                return item !== ""
            })
        }

        return data
    },

    prepareForUpdate: function (profile) {
        profile.media.forEach((media) => {
            if (media.id) {
                let id = `${media.id}`.replace('/media/', '')
                media.id = `/media/${id}`
            }
        })

        for (let feeIndex in profile.fees) {
            let fee = profile.fees[feeIndex]
            if (fee['@id']) {
                fee.id = fee['@id']
            }

            if (!profile.types.includes(fee.type)) {
                this.$delete(profile.fees, feeIndex)
            }
        }

        for (let pastJobIndex in profile.pastJobs) {
            let pastJob = profile.pastJobs[pastJobIndex]
            if (pastJob['@id']) {
                pastJob.id = pastJob['@id']
            }
        }

        return profile
    },

    resetFormMessages: function (errors) {
        Object.keys(errors).forEach((error) => {
            errors[error] = ''
        })
    },

    processErrorMessages: function (messages, errors) {
        if (messages.violations) {
            messages.violations.forEach((error) => {
                Vue.set(errors, error.propertyPath, error.message)
            })
        }
    },

    getFeeObject(profile, type) {
        if (profile.fees['hydra:member']) {
            profile.fees = profile.fees['hydra:member']
        }
        let feeObject = profile?.fees?.filter(fee => {
            return fee.type === type
        })

        if (!feeObject.length) {
            feeObject = {
                type: type,
                amount: 0
            }

            if (profile?.types.includes(type)) {
                profile?.fees.push(feeObject)
            }

            return feeObject
        }

        return feeObject[0]
    },

    updateProfileFees(profile, type) {
        if (!profile?.types.includes(type)) {
            let feeObject = profile?.fees?.filter(fee => {
                return fee.type === type
            })

            if (feeObject.length) {
                let index = profile?.fees.indexOf(feeObject[0])
                this.$delete(profile.fees, index)
            }
        }
    },

    validatePastJobDescription(description) {
        if (description?.length > 250) {
            return 'Tamanho máximo: 250 caracteres'
        }

        return true
    },

    limitPastJobDescription(description) {
        if (description.length > 250) {
            description = description.slice(0, 250)
        }
    },

    showCompletedCourseDetails(course) {
        this.completedCourseDetails = {
            ...course,
            show: true
        }
    },

    hideCompletedCourseDetails() {
        this.completedCourseDetails = {
            show: false,
            image: null,
            name: null,
            description: null
        }
    },

    updateSymplaParticipations() {
        const self = this,
            api = getApiClient(self.$store),
            userId = self.$store.state.session.user.id

        return api.patch(`professional/sympla_participations/${userId}`, self.$store.state.session.user.symplaParticipations, {
            'headers': {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.$store.commit('updateSymplaParticipations', result.data.symplaParticipations)
            })
            .catch((error) => {
                console.log(error)
            })
    },

    fillWorkProfiles() {
        const self = this

        if (self.user.workProfiles['hydra:member']?.length) {
            const profiles = self.user.workProfiles['hydra:member']

            profiles.forEach((profile) => {
                self.fillMediaSlots(profile)
                if (! profile.pastJobs.length) {
                    self.appendPastJob(profile.pastJobs)
                }
                self.$refs[profile.category].profile = profile
            })
        }
    }
}
